/* global translations globals */
/* eslint max-len: ["error", { "code": 150 }] */
/* eslint no-underscore-dangle: ["error", { "allow": ["_id", "_searchQuery", "_maxListeners",
"_questionNames", "_adminQuestionNames", "_defaultParams", "_params"] }] */
/* eslint func-names: ["error", "never"] */
import _ from 'lodash';
import { EventEmitter } from 'events';
import assign from 'object-assign';
import AppDispatcher from '../dispatcher/AppDispatcher';

const CHANGE_QUERY_EVENT = 'changeQuestions';
const CHANGE_PARAMS_EVENT = 'changeParams';
const CHANGE_PARAMS_SUBMIT_EVENT = 'changeParamsSubmit';

let _searchQuery = '';
const _questionNames = {
  'sex.F': translations['txt: Sieviete'],
  'sex.M': translations['txt: Vīrietis'],
  age: translations['txt: Vecums'],
  name: translations['txt: Vārds'],
};
const _adminQuestionNames = {
  email: translations['txt: E-pasts'],
  status: translations['txt: Statuss'],
  v2_data_id: translations['txt: Vecais ID'],
  draugiem_id: translations['txt: Draugiem ID'],
  facebook_id: translations['txt: Facebook ID'],
  gplus_id: translations['txt: Google+'],
  mailee_id: translations['txt: Mailee ID'],
  vk_id: translations['txt: VK ID'],
  itunes_id: translations['txt: Itunes maks. id'],
  phone: translations['txt: Tālruņa nr.'],
  ip: translations['txt: IP adrese'],
  ip_history: translations['txt: IP vēsture'],
  ip_range: translations['txt: IP diapazons'],
  // TODO te vēl varētu izdomāt ko citu, bet tas ir tikai adminam
  birth_day: `${translations['txt: Dzimšanas datums']} (day)`,
  birth_month: `${translations['txt: Dzimšanas datums']} (month)`,
  birth_year: `${translations['txt: Dzimšanas datums']} (year)`,
};

const hasVerification = _.get(globals, 'hasVerification', false);

let _params = {};
EventEmitter.prototype._maxListeners = 0; // neierobežots eventu daudzums

const integerRegex = /^\d+$/;

const SearchParamsStore = assign({}, EventEmitter.prototype, {

  emitChange() {
    this.emit(CHANGE_QUERY_EVENT);
  },

  emitParamsChange() {
    this.emit(CHANGE_PARAMS_EVENT);
  },

  emitParamsChangeSubmit() {
    this.emit(CHANGE_PARAMS_SUBMIT_EVENT);
  },

  addChangeQueryListener(callback) {
    // Pirms pievieno jauno, aizvāc vecos, ja tādi ir, jo jābūt tikai vienam
    if (this.listenerCount(CHANGE_QUERY_EVENT)) {
      this.removeAllListeners(CHANGE_QUERY_EVENT);
    }
    this.on(CHANGE_QUERY_EVENT, callback);
  },

  removeChangeQueryListener(callback) {
    this.removeListener(CHANGE_QUERY_EVENT, callback);
  },

  addChangeParamsListener(callback) {
    // Pirms pievieno jauno, aizvāc vecos, ja tādi ir, jo jābūt tikai vienam
    if (this.listenerCount(CHANGE_PARAMS_EVENT)) {
      this.removeAllListeners(CHANGE_PARAMS_EVENT);
    }
    this.on(CHANGE_PARAMS_EVENT, callback);
  },

  removeChangeParamsListener(callback) {
    this.removeListener(CHANGE_PARAMS_EVENT, callback);
  },

  addChangeParamsSubmitListener(callback) {
    // Pirms pievieno jauno, aizvāc vecos, ja tādi ir, jo jābūt tikai vienam
    if (this.listenerCount(CHANGE_PARAMS_SUBMIT_EVENT)) {
      this.removeAllListeners(CHANGE_PARAMS_SUBMIT_EVENT);
    }
    this.on(CHANGE_PARAMS_SUBMIT_EVENT, callback);
  },

  removeChangeParamsSubmitListener(callback) {
    this.removeListener(CHANGE_PARAMS_SUBMIT_EVENT, callback);
  },

  setQuery(value) {
    _searchQuery = value;
    SearchParamsStore.emitChange();
  },

  getQuery() {
    return _searchQuery;
  },

  toggleVal(array, val) {
    const value = integerRegex.test(val) ? parseInt(val, 10) : val;

    if (typeof array === 'undefined') {
      return [value];
    }

    const index = array.indexOf(value);

    if (index === -1) {
      array.push(value);
      return array;
    }

    array.splice(index, 1);
    return array;
  },

  getSearchParams() {
    if (_.isEmpty(_params)) {
      _params = SearchParamsStore.getDefaultParams();
    }

    return _params;
  },

  setDefaultVal(key, value) {
    const defaultValues = SearchParamsStore.getDefaultParams();
    if (typeof defaultValues[key] !== 'undefined') {
      if (typeof defaultValues[key] === 'object') {
        _params[key] = SearchParamsStore.toggleVal(_params[key], value);
      } else {
        _params[key] = defaultValues[key];
      }
    } else if (typeof _params[key] === 'object') {
      _params[key] = SearchParamsStore.toggleVal(_params[key], value);
    } else {
      _params[key] = '';
    }

    if (key === 'height') {
      _params.height_min = defaultValues.height_min;
      _params.height_max = defaultValues.height_max;
    }

    if (key === 'age') {
      _params.age_min = defaultValues.age_min;
      _params.age_max = defaultValues.age_max;
    }

    // Noņemot valsti, noņemt arī pilsētu
    if (key === '86') {
      _params['86'] = '';
      _params['88'] = [];
    }

    if (key === '88') {
      _params['88'] = [];
    }

    SearchParamsStore.emitParamsChange();
    SearchParamsStore.emitParamsChangeSubmit();
  },

  setSearchParam(key, val) {
    if (_params[key] === val) {
      return;
    }

    _params[key] = val;
    SearchParamsStore.emitParamsChange();

    if (key === 'order') {
      SearchParamsStore.emitParamsChangeSubmit();
    }
  },

  setAllSearchParams(data) {
    const params = {};
    // Šis, būtībā, ir nepieciešams, jo norefrešojot lapu ar parametriem,
    // visi šajā vietā ir string formātā.
    // Un te tos attiecīgi pārveido par boolean, integer, array. Vai dažos gadījumos arī atstāj string.
    Object.keys(data).forEach((key) => {
      const value = data[key];
      // Ja vērtība nav string, tad viss ok
      if (typeof value !== 'string') {
        params[key] = value;
        return;
      }

      // Ja vērtība tukša, tad standarta jautājumiem, kuru key ir jautājuma numurs, vērtība būs array
      // Arī dzimumam vērtība ir array
      // Pārējiem, piemēram 'name', vērtība būs tukšs string
      if (!value) {
        params[key] = integerRegex.test(key) || key === 'sex' ? [] : '';
        return;
      }

      // true/false
      if (value === 'true' || value === 'false') {
        params[key] = value === 'true';
        return;
      }

      // Ja string vērtību ir vesels skaitlis, tad iestata to
      if (integerRegex.test(value)) {
        // Ja tas ir kāds no standarta checkbox jautājumiem ar tikai vienu atbildi (un ne valsts), tad iestata kā array
        if (integerRegex.test(key) && key !== '86') {
          params[key] = [parseInt(value, 10)];
          return;
        }
        params[key] = parseInt(value, 10);
        return;
      }

      // Ja:
      // - tiek iestatīts dzimums
      // - vērtība ir ar komatiem (paredzēts kā array) un tas nav vārds (kur teorētiski var ievadīt arī komatus)
      // - standarta jautājums, kam key ir cipars un vērtība paredzēta kā array,
      // pārveido par array un arī pārbauda vai vērtībām nav jābūt skaitļiem
      if (key === 'sex' || (value.includes(',') && key !== 'name') || integerRegex.test(key)) {
        params[key] = value.split(',').map((val) => {
          // Pārbauda arī katru atsevišķo vērtību, vai tā nav paredzēta kā integer nevis string
          if (integerRegex.test(val)) {
            return parseInt(val, 10);
          }
          return val;
        });
        return;
      }

      // Ja tiek līdz šim, tad vērtībai tiešām jābūt string
      // Piemēram, šobrīd tas, noteikti, ir order, kur var būt 'last_action', 'created' vai 'closest'
      params[key] = value;
    });

    // Pārbauda vai ir visi lauki, kuriem noteikti jābūt. Ja nav, tad iestata noklusējuma vērtību
    const defaultParams = SearchParamsStore.getDefaultParams();
    Object.keys(defaultParams).forEach((key) => {
      if (!Object.prototype.hasOwnProperty.call(params, key)) {
        params[key] = defaultParams[key];
      }
    });

    _params = params;
  },

  getDefaultParams() {
    const _defaultParams = {
      order: 'last_action',
      sex: [],
      name: '',
      only_if_prefered: false,
      only_if_prefered_sex: false,
      age_min: 18,
      age_max: 120,
      height_min: 0,
      height_max: 220,
      82: [],
      86: '',
      88: [],
      image: false,
      not_visited: false,
      verified: false,
    };

    /*
    if (hasVerification) {
      _defaultParams.verified = false;
    }
    */

    return _defaultParams;
  },

  setQuestionNames(data) {
    if (typeof data === 'undefined') {
      return;
    }

    const questionData = data;
    let questions = false;
    let additionalQuestions = false;
    if (typeof questionData.questions !== 'undefined') {
      questions = questionData.questions; // eslint-disable-line prefer-destructuring
    }

    if (questions !== false) {
      Object.values(questions).forEach((question) => {
        let questionId = null;
        if (typeof question._id !== 'undefined') {
          questionId = question._id.toString();
        }

        if (typeof question.id !== 'undefined') {
          questionId = question.id.toString();
        }

        _questionNames[questionId] = question.title;
        Object.values(question.answers).forEach((answer) => {
          if (typeof answer._id !== 'undefined') {
            _questionNames[`${questionId}.${answer._id}`] = answer.title;
          }

          if (typeof answer.id !== 'undefined') {
            _questionNames[`${questionId}.${answer.id}`] = answer.title;
          }
        });
      });
    }

    if (typeof questionData.additional_questions !== 'undefined') {
      additionalQuestions = questionData.additional_questions; // eslint-disable-line prefer-destructuring
    }

    if (additionalQuestions !== false) {
      Object.values(additionalQuestions).forEach((additionalQuestion) => {
        let additionalQuestionId = null;
        if (typeof additionalQuestion._id !== 'undefined') {
          additionalQuestionId = additionalQuestion._id.toString();
        }

        if (typeof additionalQuestion.id !== 'undefined') {
          additionalQuestionId = additionalQuestion.id.toString();
        }

        _questionNames[additionalQuestionId] = additionalQuestion.title;
        Object.values(additionalQuestion.answers).forEach((answer) => {
          let answerTitle = answer.title;
          if (typeof answer.translations.title[globals.locale] !== 'undefined') {
            answerTitle = answer.translations.title[globals.locale];
          }

          if (typeof answer._id !== 'undefined') {
            _questionNames[`${additionalQuestionId}.${answer._id}`] = answerTitle;
          }

          if (typeof answer.id !== 'undefined') {
            _questionNames[`${additionalQuestionId}.${answer.id}`] = answerTitle;
          }
        });
      });
    }
  },

  getQuestionNames() {
    return _questionNames;
  },

  getParams(query) {
    if (!query) {
      return { };
    }

    return (/^[?#]/.test(query) ? query.slice(1) : query)
      .split('&')
      .reduce((params, param) => {
        const [key, value] = param.split('=');
        params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : ''; // eslint-disable-line no-param-reassign
        return params;
      }, { });
  },

  getTags() {
    const tagNames = SearchParamsStore.getQuestionNames();
    const tags = [];
    const params = SearchParamsStore.getParams(_searchQuery);

    // Te var pievienot jautājumu numurus, kuriem nav jārāda jautājums.
    // Piemēram, ja pēc atbildēm jau viss ir skaidrs.
    // Kas neattiecas uz jautājumiem, kur kāda no atbildēm ir 'Jā', 'Nē', 'Brūna', 'Pelēka', utt..
    // Šādas atbildes ir vairākiem jautājumiem.
    // Tapēc, ja jautājuma numurs nav iekļauts te, tad tagā, pie atbildes tiks pievienots arī pats jautājums.
    // Attiecas tikai uz jautājumiem, kuriem ir numurs.
    // Šim vēl var padomāt kādu labāku risinājumu.
    const dontAddQuestion = [82, 86, 88, 1, 10, 14, 30, 40, 54, 89, 111];

    const defaultParams = SearchParamsStore.getDefaultParams();

    if (typeof params.height_min !== 'undefined' || typeof params.height_max !== 'undefined') {
      if (typeof params.height_min === 'undefined') {
        params.height_min = defaultParams.height_min;
      }

      if (typeof params.height_max === 'undefined') {
        params.height_max = defaultParams.height_max;
      }

      if (defaultParams.height_min.toString() !== params.height_min.toString()
        || defaultParams.height_max.toString() !== params.height_max.toString()
      ) {
        tags.height = { title: `${translations['txt: Augums (cm)']} ${params.height_min}-${params.height_max}`, value: '', key: 'height' };
      }
    }

    if (typeof params.age_min !== 'undefined' || typeof params.age_max !== 'undefined') {
      if (typeof params.age_min === 'undefined') {
        params.age_min = defaultParams.age_min;
      }

      if (typeof params.age_max === 'undefined') {
        params.age_max = defaultParams.age_max;
      }

      if (defaultParams.age_min.toString() !== params.age_min.toString()
        || defaultParams.age_max.toString() !== params.age_max.toString()
      ) {
        tags.age = { title: `${translations['txt: Vecums']} ${params.age_min}-${params.age_max}`, value: '', key: 'age' };
      }
    }

    if (typeof params.name !== 'undefined' && params.name !== '') {
      tags.name = { title: `${tagNames.name}: ${params.name}`, value: params.name, key: 'name' };
    }

    if (typeof params.image !== 'undefined' && params.image && params.image !== 'false') {
      tags.image = { title: translations['txt: Ar fotogrāfiju'], value: '1', key: 'image' };
    }

    if (hasVerification && typeof params.verified !== 'undefined' && params.verified && params.verified !== 'false') {
      tags.verified = { title: translations['txt: Verificēts profils'], value: '1', key: 'verified' };
    }

    if (typeof params.not_visited !== 'undefined' && params.not_visited && params.not_visited !== 'false') {
      tags.not_visited = { title: translations['txt: Neapskatīti'], value: '1', key: 'not_visited' };
    }

    if (typeof params.only_if_prefered !== 'undefined' && params.only_if_prefered && params.only_if_prefered !== 'false') {
      tags.only_if_prefered = { title: translations['txt: only prefered'], value: '1', key: 'only_if_prefered' };
    }

    if (typeof params.only_if_prefered_sex !== 'undefined' && params.only_if_prefered_sex && params.only_if_prefered_sex !== 'false') {
      tags.only_if_prefered_sex = { title: translations['txt: only prefered sex'], value: '1', key: 'only_if_prefered_sex' };
    }

    Object.entries(params).forEach((param) => {
      if (!param[1].length) {
        return;
      }

      if (param[1].indexOf(',') !== -1 && param[0] !== '88') {
        const value = param[1].split(',');

        Object.values(value).forEach((val) => {
          if (typeof tagNames[`${param[0]}.${val}`] === 'undefined') {
            return;
          }

          let valueName = tagNames[`${param[0]}.${val}`];
          if (integerRegex.test(param[0]) && !dontAddQuestion.includes(parseInt(param[0], 10))) {
            const questionName = tagNames[param[0]];
            valueName = `${questionName}: ${valueName}`;
          }

          tags[`${param[0]}.${val}`] = { title: valueName, value: val, key: param[0] };
        });
        return;
      }

      if (Object.prototype.hasOwnProperty.call(_adminQuestionNames, param[0])) {
        tags[param[0]] = { title: `${_adminQuestionNames[param[0]]}: ${param[1]}`, value: param[1], key: param[0] };
        return;
      }

      if (typeof tagNames[`${param[0]}.${param[1]}`] === 'undefined') {
        return;
      }

      let valueName = tagNames[`${param[0]}.${param[1]}`];
      if (integerRegex.test(param[0]) && !dontAddQuestion.includes(parseInt(param[0], 10))) {
        const questionName = tagNames[param[0]];
        valueName = `${questionName}: ${valueName}`;
      }

      tags[`${param[0]}.${param[1]}`] = { title: valueName, value: param[1], key: param[0] };
    });

    return tags;
  },
});

SearchParamsStore.dispatchToken = AppDispatcher.register((action) => {
  switch (action.type) {
    default:
      // do nothing
  }
});

module.exports = SearchParamsStore;
